"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const utilitycancelanytime = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 64 66",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-utilitycancelanytime` : '') + (description ? ` desc-utilitycancelanytime` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-utilitycancelanytime"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-utilitycancelanytime"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M61 32.95c0 16.5-12.98 29.87-29 29.87-16 0-29-13.37-29-29.87S15.98 3.1 32 3.1c16 0 29 13.36 29 29.85Z",
    fill: "#B30000"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M45.26 19.91a3.87 3.87 0 0 1 0 5.36l-20.8 21.4a3.6 3.6 0 0 1-5.2 0 3.87 3.87 0 0 1 0-5.34l20.8-21.42a3.6 3.6 0 0 1 5.2 0Z",
    fill: "#FFE5E5"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M19.26 19.91a3.87 3.87 0 0 0 0 5.36l20.8 21.4a3.6 3.6 0 0 0 5.2 0 3.87 3.87 0 0 0 0-5.34L24.46 19.9a3.6 3.6 0 0 0-5.19 0Z",
    fill: "#FFE5E5"
  }));
};
var _default = exports.default = utilitycancelanytime;